import Timestamp from "components/Timestamp";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ModulePullRequestsTableRow } from "../../../gql";
import ModulePullRequestsTableGroupCell from "../../GroupCell";

const ModulePullRequestsTablePullRequestUpdatedAtCell = ({
  item: pullRequest,
  ...cellProps
}: TableSimpleCellProps<ModulePullRequestsTableRow>) => {
  return (
    <ModulePullRequestsTableGroupCell item={pullRequest} {...cellProps}>
      <Timestamp timestamp={pullRequest.updatedAt} />
    </ModulePullRequestsTableGroupCell>
  );
};

export default ModulePullRequestsTablePullRequestUpdatedAtCell;
